import { fetchAdministrationDashboard } from "../../api/administrationDashboard";
import { createResourceLoader } from "./keyedResourceLoader";
import type { AdministrationSlice, DashboardSlice } from "./types";

const loader = createResourceLoader();
export const dashboardInitialState = {
  dashboard: null,
  dashboardFetchedAt: null,
  dashboardHydrated: false,
  dashboardLoading: false,
  dashboardError: "",
};
export const resetDashboardRequests = loader.clear;
export const createDashboardSlice: AdministrationSlice<DashboardSlice> = (set, get) => ({
  ...dashboardInitialState,
  loadDashboard: (force = false) => loader.load({
    force,
    cached: get().dashboardHydrated,
    request: fetchAdministrationDashboard,
    onStart: () => set({ dashboardLoading: true, dashboardError: "" }),
    onSuccess: (dashboard) => set({ dashboard, dashboardFetchedAt: Date.now(), dashboardHydrated: true }),
    onError: (dashboardError) => set({ dashboardError }),
    onFinish: () => set({ dashboardLoading: false }),
    errorMessage: "Unable to load dashboard.",
  }),
});
